import appStore from 'store';
import api from './api';

const store = {
    namespaced: true,
    state: {
        createDialogVisible: false,
        orderDialogVisible: false,
        currId:"",
        coinTypes:[],
        pairTypes:[],
        country:[],
        chain:[],
    },
    getters: {
        getCurrId: state => {
            return state.currId;
        },
        getCreateDialogVisible: state => {
            return state.createDialogVisible;
        },
        getOrderDialogVisible: state => {
            return state.orderDialogVisible;
        },
        getCoinTypes: state => {
            return state.coinTypes;
        },
        getPairTypes: state => {
            return state.pairTypes;
        },
        getCountry: state => {
            return state.country;
        },
        getChain: state => {
            return state.chain;
        },
    },
    mutations: {
        toggleCurrId(state, payload) {
            state.currId = payload;
        },
        toggleCreateDialogVisible(state, payload) {
            state.createDialogVisible = payload;
        },
        toggleOrderDialogVisible(state, payload) {
            state.orderDialogVisible = payload;
        },
        toggleCoinTypes(state, payload) {
            state.coinTypes = payload;
        },
        togglePairTypes(state, payload) {
            state.pairTypes = payload;
        },
        toggleCountry(state, payload) {
            state.country = payload;
        },
        toggleChain(state, payload) {
            state.chain = payload;
        },
    },
    actions: {
        setCurrId({commit}, coinType) {
            commit('toggleCurrId', coinType);
        },
        setCreateDialogVisible({commit}, state) {
            commit('toggleCreateDialogVisible', state);
        },
        setOrderDialogVisible({commit}, state) {
            commit('toggleOrderDialogVisible', state);
        },
        setCoinTypes({commit}, state) {
            commit('toggleCoinTypes', state);
        },
        setPairTypes({commit}, state) {
            commit('togglePairTypes', state);
        },
        setCountry({commit}, state) {
            commit('toggleCountry', state);
        },
        setChain({commit}, state) {
            commit('toggleChain', state);
        },
    }
}

appStore.registerModule('IncubatorManage', store);
